import BackendService from "../common/BackendService";
import OpBankResp from "./dto/OpBankResp";

const getBank = (iban: string) => {
    const params = { value: iban };

    return BackendService.getData(`rest/op/bank/iban`, params)
        .then(root => {
            return root as OpBankResp;
        })
        .catch(error => {
            // TODO Fuest logging
            throw error;
        })

}
const BankConsumer = {
    getBank
}

export default BankConsumer;